import { forwardRef, type Ref, type SVGProps } from "react";
const IconZoomOutOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M29.71 28.29 21.45 20A11 11 0 1 0 20 21.45l8.25 8.26a1 1 0 0 0 1.42 0 1 1 0 0 0 .04-1.42M13 22a9 9 0 1 1 9-9 9 9 0 0 1-9 9"
    />
    <path fill="currentColor" d="M18 12H8a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2" />
  </svg>
);
const ForwardRef = forwardRef(IconZoomOutOutlineSVG);
ForwardRef.displayName = "IconZoomOutOutline";
export { ForwardRef as IconZoomOutOutline };
